<template>
  <div id="app">
    <router-view/>
    <GuideInWeChat @click.native="close" v-if="$store.state.showGuide" />
    <!-- <img src="./站外直播页3.png" alt="" class="preview"> -->
  </div>
</template>
<script>
import GuideInWeChat from '@/components/GuideInWeChat.vue'
export default {
  components: {
    GuideInWeChat
  },
  methods: {
    close() {
      this.$store.commit('showGuideMutations', false)
    }
  }
}
</script>

<style lang="scss">
// .preview{
//   // display: none;
//   position: fixed;
//   max-width: 100%;
//   // top: -176px;
//   bottom: 0px;
//   left: 0;
//   opacity: 0.5;
// }
#app {
  color: var(--color-333333);
  font-size: 24px
  // color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    color: #2c3e50;
    font-weight: bold;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
